import React from 'react';

import styles from './Home.module.scss';
import {ContentBox, Button} from '../../../components';
import {DiscoverSong} from './components';
import vibingWoman from './vibingwoman.png';
import {useMusicKitContext} from '../../../context/MusicKitProvider';
import {mockCatalogSongs} from '../Library/mockData';
import Discover from './components/Discover';

const TEMP_IS_CONNECTED = false;

export default function Home() {
  const musicKit = useMusicKitContext();

  return (
    <div className={styles.Home}>
      {TEMP_IS_CONNECTED ? (
        <ContentBox primary>
          <div className={styles.SharingHeader}>
            Calum Patrick, Mia Colleti, &amp; 1 other are listening in.
          </div>
          <div>Sharing Content</div>
        </ContentBox>
      ) : (
        <ContentBox primary>
          <div className={styles.OnboardContentWrapper}>
            <div className={styles.OnboardHeader}>Welcome to alto.fm</div>
            <div className={styles.OnboardBody}>
              Invite friends to listen to the tracks you’re playing synchronized
              in real-time, or listen in on what your friends are playing at any
              time.
            </div>
            <div style={{width: '33%', marginTop: '28px'}}>
              <Button
                fill
                transparent
                primaryBorderColor
                onClick={() => {
                  let url =
                    'https://itunes.apple.com/us/playlist/pl.d133de76fb4f4ccf98846231899874c0';
                  musicKit
                    ?.setQueue({url: url, items: []})
                    .then(function(queue) {
                      console.log(musicKit.player.queue);
                      musicKit.player.play();
                      // Queue is instantiated and set on music player.
                    });
                }}
              >
                <span className={styles.ButtonContent}>Get Started</span>
              </Button>
            </div>
            <img
              className={styles.OnboardImage}
              alt="vibing woman"
              src={vibingWoman}
            />
          </div>
        </ContentBox>
      )}
      <div className={styles.ContentBoxWrapper}>
        <div className={styles.LeftColumn}>
          <ContentBox title="Feed">
            {mockCatalogSongs.slice(0, 7).map((song) => (
              <DiscoverSong song={song} />
            ))}
          </ContentBox>
        </div>
        <div className={styles.RightColumn}>
          <ContentBox title="Friends Are Listening To">
            {mockCatalogSongs.slice(0, 3).map((song) => (
              <DiscoverSong song={song} />
            ))}
          </ContentBox>
          <Discover />
        </div>
      </div>
    </div>
  );
}
